/**
 * As variaveis de ambiente do build, lidas **uma vez** e validadas.
 *
 * ADR-0025: nada de cliente entra no codigo. Origem da API, host de imagem e host de arquivo
 * variam por instalacao; eles entram por `import.meta.env`, e a falta de qualquer um falha
 * **no boot**, alto e cedo — um `undefined` que vira `"undefined/v1/stores"` produz um 404 sem
 * explicacao trinta telas depois.
 */

/** Injetado pelo Vite via `define` (`vite.config.ts`) — `PWA §5.1`. */
declare const __BUILD_ID__: string;

export interface Ambiente {
  /** `https://api.<dominio>` — **sem** `/v1`. Os caminhos ja o carregam (`API §6`). */
  readonly origemDaApi: string;
  /** `https://img.<dominio>` — `PWA §4.2 R07/R08`. */
  readonly origemDasImagens: string;
  /** `https://files.<dominio>` — `PWA §4.2 R17`. Nunca interceptado, sempre negado. */
  readonly origemDosArquivos: string;
  readonly buildId: string;
  readonly desenvolvimento: boolean;
}

function obrigatoria(nome: string, valor: string | undefined): string {
  if (valor === undefined || valor === '') {
    throw new Error(
      `Variavel de ambiente ausente: ${nome}. Sem ela o app sobe e falha em cada requisicao.`,
    );
  }
  return valor.replace(/\/+$/, '');
}

export function lerAmbiente(env: ImportMetaEnv): Ambiente {
  return {
    origemDaApi: obrigatoria('VITE_API_ORIGIN', env.VITE_API_ORIGIN),
    origemDasImagens: obrigatoria('VITE_IMG_ORIGIN', env.VITE_IMG_ORIGIN),
    origemDosArquivos: obrigatoria('VITE_FILES_ORIGIN', env.VITE_FILES_ORIGIN),
    buildId: typeof __BUILD_ID__ === 'string' ? __BUILD_ID__ : 'dev',
    desenvolvimento: env.DEV,
  };
}
